export default __webpack_public_path__ + "static/mess-22701fc6dad0d1f3bd268c12dd078449.png";